import staffMissionCatalog from '../../../views/Teams/staffMissionCatalog.json';

const catalogCodesSet = (() => {
  const set = new Set();
  Object.values(staffMissionCatalog.groups).forEach((codes) => {
    codes.forEach((code) => set.add(code));
  });
  return set;
})();

const checkStaffMissionCatalogDrift = (flatQrMenu) => {
  const qrLeafCodes = new Set();
  flatQrMenu.forEach((entry) => {
    if (entry.end) qrLeafCodes.add(entry.ccatCode);
  });

  const missingFromCatalog = [];
  qrLeafCodes.forEach((code) => {
    if (!catalogCodesSet.has(code)) missingFromCatalog.push(code);
  });

  const missingFromQrMenu = [];
  catalogCodesSet.forEach((code) => {
    if (!qrLeafCodes.has(code)) missingFromQrMenu.push(code);
  });

  if ((!missingFromCatalog.length) && (!missingFromQrMenu.length)) return null;

  return { missingFromCatalog, missingFromQrMenu };
};

export default checkStaffMissionCatalogDrift;
